import { VistoriaFCA } from "@/mocks/fca";
import { estadoFitoConfig, riscoConfig } from "@/mocks/cta";

interface Props {
  vistorias: VistoriaFCA[];
}

export default function TreeInspectionTable({ vistorias }: Props) {
  const formatDate = (dateStr: string) => {
    const [y, m, d] = dateStr.split("-");
    return `${d}/${m}/${y}`;
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-foreground-900 font-heading flex items-center gap-2">
          <i className="ri-clipboard-line text-primary-500"></i>
          Histórico de Vistorias
        </h3>
        <button className="btn-primary text-xs">
          <i className="ri-add-line"></i>
          Nova vistoria
        </button>
      </div>
      <div className="bg-white rounded-card border border-background-200/70 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-background-200 bg-background-50">
                <th className="text-left text-[11px] font-semibold text-foreground-500 uppercase tracking-wide px-4 py-2.5 whitespace-nowrap">Data</th>
                <th className="text-left text-[11px] font-semibold text-foreground-500 uppercase tracking-wide px-4 py-2.5 whitespace-nowrap">Tipo</th>
                <th className="text-left text-[11px] font-semibold text-foreground-500 uppercase tracking-wide px-4 py-2.5 whitespace-nowrap">Técnico</th>
                <th className="text-left text-[11px] font-semibold text-foreground-500 uppercase tracking-wide px-4 py-2.5 whitespace-nowrap">Estado Fito</th>
                <th className="text-left text-[11px] font-semibold text-foreground-500 uppercase tracking-wide px-4 py-2.5 whitespace-nowrap">Risco</th>
                <th className="text-left text-[11px] font-semibold text-foreground-500 uppercase tracking-wide px-4 py-2.5 whitespace-nowrap">DAP</th>
                <th className="text-left text-[11px] font-semibold text-foreground-500 uppercase tracking-wide px-4 py-2.5 whitespace-nowrap">Altura</th>
                <th className="text-left text-[11px] font-semibold text-foreground-500 uppercase tracking-wide px-4 py-2.5 whitespace-nowrap">Recomendação</th>
                <th className="text-left text-[11px] font-semibold text-foreground-500 uppercase tracking-wide px-4 py-2.5 whitespace-nowrap">Status</th>
                <th className="text-left text-[11px] font-semibold text-foreground-500 uppercase tracking-wide px-4 py-2.5 whitespace-nowrap">Ações</th>
              </tr>
            </thead>
            <tbody>
              {vistorias.map((v) => {
                const ef = estadoFitoConfig[v.estadoFito] || { badge: "", label: v.estadoFito };
                const rk = riscoConfig[v.risco] || { badge: "", label: v.risco };
                return (
                  <tr key={v.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                    <td className="px-4 py-3 text-sm text-foreground-900 font-medium whitespace-nowrap">{formatDate(v.data)}</td>
                    <td className="px-4 py-3 text-sm text-foreground-700 whitespace-nowrap">{v.tipo}</td>
                    <td className="px-4 py-3 text-sm text-foreground-700 whitespace-nowrap">{v.tecnico}</td>
                    <td className="px-4 py-3 whitespace-nowrap"><span className={`badge ${ef.badge}`}>{ef.label}</span></td>
                    <td className="px-4 py-3 whitespace-nowrap"><span className={`badge ${rk.badge}`}>{rk.label}</span></td>
                    <td className="px-4 py-3 text-sm text-foreground-700 whitespace-nowrap">{v.dap} cm</td>
                    <td className="px-4 py-3 text-sm text-foreground-700 whitespace-nowrap">{v.altura} m</td>
                    <td className="px-4 py-3 text-sm text-foreground-700 whitespace-nowrap">{v.recomendacao}</td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      <span className={`badge ${v.status === "Concluída" ? "bg-primary-100 text-primary-700" : "bg-warning-100 text-warning-700"}`}>
                        {v.status}
                      </span>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      <div className="flex items-center gap-1">
                        <button className="w-7 h-7 rounded-md flex items-center justify-center text-foreground-500 hover:text-accent-500 hover:bg-accent-50 transition-colors" title="Ver detalhes">
                          <i className="ri-eye-line text-sm"></i>
                        </button>
                        <button className="w-7 h-7 rounded-md flex items-center justify-center text-foreground-500 hover:text-primary-500 hover:bg-primary-50 transition-colors" title="Abrir relatório">
                          <i className="ri-file-text-line text-sm"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}